<template>
  <div id="maintop">
    <div  v-if="flag">

    <b-input
      class="mb-2 mr-sm-2 mb-sm-0 title"
      placeholder="请输入标题" v-model="title"
    ></b-input>

    <div id="main">
      <b-form-textarea
              id="textarea"
              v-model="text"
              placeholder="请输入摘要"
              rows="3"
              max-rows="6"
      ></b-form-textarea>
    </div>

    <br>
    <b-input
      class="mb-2 mr-sm-2 mb-sm-0"
      placeholder="tags  (输入英文标签，以空格分隔)" v-model="tags"
    ></b-input>

    <div class="btn">
      <b-button variant="outline-primary" @click="post">提交</b-button>
    </div>

    </div>
    <!--加载动画-->
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>

  </div>
</template>

<script>
  import Loading from './Loading'
    export default {
        name: "Post",
      data() {
        return {
          db:{},
          title: '',
          text:'',
          tags: '',
          isLoading: false,
          flag: true
        }
      },

      methods: {
        post(){
            this.flag = false
            this.isLoading = true
            let wif = this.$store.state.password
            let parentAuthor = ''
            let parentPermlink = 'starnote'
            let author = this.$store.state.username
            let permlink = this.getstr()
            let title = this.title
            let text = this.text
            let temp = 'starnote ' + this.tags
            let tags = temp.trim().split(/\s+/)
            let tail = '\n -> 前往[星空笔记](https://starnote.github.io/#/@'+author+'/'+permlink+')'
            let body = text+tail
            let jsonMetadata = {"tags": tags, "dapp": "starnote", "format": "markdown", "text": text}

            //发布到steem上
            // this.postToSteem(wif, parentAuthor, parentPermlink, author, permlink, title, body, jsonMetadata)

            //发布到本地数据库
            //把数据拼成一个JSON
            let post = {
              "title": title,
              "author": author,
              "permlink": permlink,
              "parent_author": '',
              "parent_permlink": 'starnote',
              "category": "starnote",
              "body": body,
              "created": new Date().toISOString().split('.')[0],
              "json_metadata": JSON.stringify(jsonMetadata)
            }

          let that = this
          let db = this.$store.state.db
          const titleName = this.$store.state.username + 'title'

          async function main(){
            await that.saveOneToDb(post, db, titleName)

            //发布到steem上
            await that.postToSteemPro(wif, parentAuthor, parentPermlink, author, permlink, title, body, jsonMetadata)

            //发布到hive上
            //that.hive.api.setOptions({ url: 'https://anyx.io' })
            //await that.postToHive(wif, parentAuthor, parentPermlink, author, permlink, title, body, jsonMetadata)

            //切换回节点
            // that.steem.api.setOptions({ url: 'https://api.steemjiang.com' })
            //that.steem.api.setOptions({ url: 'https://cn.steems.top' })

            let posts = await that.getAllPosts(db)
            that.$store.commit('savePosts', posts.reverse())
            //发布完后跳转
            that.$router.push({path: '/manage'})
          }
          main()
          },


      },
      components: {
        Loading
      },

      mounted() {
        let _this = this
        async function main(){
          if(_this.$store.state.username){
            //如果已登录
            if(_this.$store.state.posts == false){
              //第一次打开页面或是刷新
              let db = await _this.initDatabase()
              _this.$store.commit('saveDB',db)
              let posts = await _this.getAllPosts(db)
              _this.$store.commit('savePosts', posts.reverse())
            }
          }else{
            _this.$router.push({path: '/login'})
          }

        }
        main()
      }
    }
</script>

<style scoped>
   #maintop{
    width: 60%;
    margin: 0 auto;
  }


  .title{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem !important;
    width: 60%;
  }
  .btn{
    margin-top: 0.3rem;
  }
</style>
